export default __webpack_public_path__ + "static/media/new-hockey-playerlogo.286ea80d.png";